<template>
  <li>
    <div class="relative pb-8">
      <span
        class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200"
        v-if="separator"
      />
      <div class="relative flex space-x-3">
        <div>
          <slot name="icon" />
        </div>
        <div class="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
          <slot />
        </div>
      </div>
    </div>
  </li>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
  name: 'HistoryRow',
  props: {
    separator: {
      required: false,
      type: Boolean,
      default: true,
      description: 'display or hide vertical separator',
    },
  },
}
</script>

<style scoped></style>
